import React, { useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { Plus, Trash2, RotateCcw } from "lucide-react";
import { generateInclusions } from "../_shared";

export default function StepInclusions({ q, setQ }) {
  const [val, setVal] = useState("");
  const didAuto = useRef(false);

  useEffect(() => {
    if (didAuto.current) return;
    didAuto.current = true;
    if ((q.inclusions || []).length > 0) return;
    const suggestions = generateInclusions(q);
    if (suggestions.length) setQ((p) => ({ ...p, inclusions: suggestions }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const add = () => {
    if (!val.trim()) return;
    setQ((p) => {
      const exists = (p.inclusions || []).some((x) => x.toLowerCase() === val.trim().toLowerCase());
      if (exists) return p;
      return { ...p, inclusions: [...(p.inclusions || []), val.trim()] };
    });
    setVal("");
  };
  const rem = (i) => setQ((p) => ({ ...p, inclusions: p.inclusions.filter((_, idx) => idx !== i) }));
  const updItem = (i, v) => setQ((p) => ({ ...p, inclusions: p.inclusions.map((x, idx) => idx === i ? v : x) }));

  const regenerate = () => {
    const suggestions = generateInclusions(q);
    setQ((p) => {
      const existing = p.inclusions || [];
      const seen = new Set(existing.map((x) => x.toLowerCase()));
      const merged = [...existing];
      suggestions.forEach((s) => {
        if (!seen.has(s.toLowerCase())) { merged.push(s); seen.add(s.toLowerCase()); }
      });
      return { ...p, inclusions: merged };
    });
    toast.success("Suggestions refreshed from earlier steps");
  };

  return (
    <>
      <div className="flex gap-2">
        <input data-testid="inclusions-input" value={val} onChange={(e)=>setVal(e.target.value)} onKeyDown={(e)=>{ if (e.key==="Enter") add(); }}
          placeholder="e.g., Return flights, Hotel breakfasts, Airport transfers" className="flex-1 border border-border rounded px-3 py-2 text-sm" />
        <button data-testid="inclusions-add-btn" onClick={add} className="btn-bronze"><Plus size={15} /></button>
      </div>
      <div className="mt-3 flex items-center justify-between">
        <span className="text-xs text-slate-500">
          {(q.inclusions || []).length} item{(q.inclusions || []).length === 1 ? "" : "s"} — auto-generated from your Hotels, Flights &amp; Itinerary
        </span>
        <button data-testid="inclusions-regen-btn" onClick={regenerate} className="text-xs text-emerald-700 hover:underline flex items-center gap-1">
          <RotateCcw size={12} /> Regenerate suggestions
        </button>
      </div>
      <ul className="mt-3 space-y-1.5">
        {(q.inclusions || []).map((x, i) => (
          <li key={i} data-testid={`inclusions-item-${i}`} className="flex items-center gap-2 bg-slate-50 border border-border rounded px-3 py-2 text-sm">
            <input
              data-testid={`inclusions-edit-${i}`}
              value={x}
              onChange={(e) => updItem(i, e.target.value)}
              className="flex-1 bg-transparent outline-none"
            />
            <button data-testid={`inclusions-rem-${i}`} onClick={()=>rem(i)} className="text-red-500"><Trash2 size={13} /></button>
          </li>
        ))}
      </ul>
    </>
  );
}
